import React, {useEffect, useState} from 'react';
import Modal from 'antd/es/modal/Modal';
import {
  Card,
  Form,
  Input,
  DatePicker,
  Button,
  Upload,
  Row,
  Col,
  message,
  Select,
} from 'antd';
import {CloseCircleFilled, UploadOutlined} from '@ant-design/icons';
import {useDispatch} from 'react-redux';
import dayjs from 'dayjs';
import {createJobs, editJobs} from '../../../../Store/Actions/jobs';
import CommonEditor from '../../../CommonComponents/TextEditor';
import {applicationConfig} from '../../../../Util/config';
import {useNavigate} from 'react-router-dom';
import {
  NoEmptySpaceInput,
  UploadFileMaxSize,
  displayFileName,
  disablePrevDatesHandler,
  urlOrEmailValidator,
  validateMonthsInput,
} from '../../../../Util/commonUtility';
import {FETCH_ERROR} from '../../../../Constant/ActionTypes';
import useLocalization from '../../../../Localization';

const JobsFormComponent = (props) => {
  const {ApplicationString} = useLocalization();
  const {isModalOpen, setIsModalOpen, editData, jobFeesOptions, zeroFeeData} =
    props;
  const [editorDescState, setEditorDescState] = useState(`<p></p>`);
  const [editorReqState, setEditorReqState] = useState(`<p></p>`);
  const [validFileList, setValidFileList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onFinish = (values) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const addHttpsToAttachmentUrl = `${values?.attachment_url}`;

    const data = new FormData();
    // const file_logo = values.file_logo
    //   ? values.file_logo.map((item) => {
    //       data.append('logos', item.originFileObj);
    //     })
    //   : null;
    // editData?.jobLogo
    //   ? editData?.jobLogo?.id === validFileList[0]?.uid
    //     ? data.append('logo_ids', `[${editData?.jobLogo?.id}]`)
    //     : data.append('logos', validFileList[0])
    //   : data.append('logos', validFileList[0] || []);

    data.append('position', values?.position || '');
    // data.append(
    //   'start_date',
    //   values?.start_date ? dayjs(values?.start_date).format('YYYY-MM-DD') : '',
    // );
    data.append('employer', values?.employer || '');
    data.append('description', editorDescState);
    // data.append('vacancy', values?.vacancy || 5);
    data.append('location', values?.location || '');
    data.append('requirement', editorReqState);
    data.append('contact_info', values?.contact_info || '');
    data.append('months', values?.months ? values?.months : '');
    data.append('attachment_url', addHttpsToAttachmentUrl || '');
    data.append(
      'job_fee_id',
      values?.job_fee_id ? parseInt(values?.job_fee_id) : undefined,
    );
    if (editData?.jobId) {
      dispatch(
        editJobs(
          data,
          editData.jobId,
          form,
          null,
          null,
          setIsModalOpen,
          setIsSubmitting,
        ),
      );
    } else {
      const isZeroFee =
        zeroFeeData?.length > 0
          ? values?.job_fee_id === zeroFeeData[0]?.id
          : false;
      dispatch(
        createJobs(
          data,
          form,
          navigate,
          setIsModalOpen,
          setValidFileList,
          isZeroFee,
          setIsSubmitting,
        ),
      );
    }
  };
  const handleCancel = () => {
    form.resetFields();
  };
  const handleClose = () => {
    if (isSubmitting) return;
    setIsModalOpen(false);
    form.resetFields();
    setValidFileList((prev) => []);
    setEditorDescState(`<p></p>`);
    setEditorReqState(`<p></p>`);
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const beforeUploadLogos = (file) => {
    const reader = new FileReader();
    const fileSize = file.size / 1024;

    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        if (width !== 250 && height !== 250) {
          message.error('Image must be 250px x 250px!');
          return Upload.LIST_IGNORE;
        }
      };
      if (fileSize > 2) {
        message.error('File size must not exceed 2MB!');
        return Upload.LIST_IGNORE;
      }
      return true;
    };

    reader.readAsDataURL(file);
  };
  const dummyRequest = ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };
  // const uploadPropsLogos = {
  //   name: 'fileLogos',
  //   accept: 'image/*, application/pdf',
  //   multiple: false,
  //   maxCount: 1,
  //   listType: 'picture',
  // };

  const filesFormats = ['image/png', 'image/jpeg', 'image/jpg'];

  const uploadProps = {
    name: 'file',
    multiple: true,
    maxCount: 10,
    // listType: 'picture',
    beforeUpload: (file) => {
      const isRightFormat = filesFormats.includes(file.type);
      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: JPG and PNG only',
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSize}MB.`,
        });
        return false;
      }
      if (file?.type?.includes('image')) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = () => {
            if (img.width >= 200 && img.height >= 200) {
              setValidFileList((prev) => [file]);
              resolve(isRightFormat && isLt2M);
            } else {
              dispatch({
                type: FETCH_ERROR,
                payload: 'Image size must be greater than 200x200 pixels.',
              });
              setValidFileList((prev) =>
                prev.filter((f) => f.uid !== file.uid),
              );
              reject();
            }
          };
          img.onerror = reject;
        });
      } else {
        setValidFileList((prev) => [file]);
        return isRightFormat && isLt2M;
      }
    },
  };

  const removeFileHandler = (file) => {
    setValidFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  useEffect(() => {
    if (editData && isModalOpen) {
      const findJobFeesId = jobFeesOptions?.find(
        (obj) => obj?.details === editData?.job_fee_note,
      )?.id;

      form.setFieldsValue({
        position: editData?.jobTitle,
        employer: editData?.jobEmployer,
        location: editData?.jobLocation,
        contact_info: editData?.jobContactInfo,
        attachment_url: editData?.jobUrl,
        description: editData?.jobDescription,
        requirement: editData?.jobRequirements,
        job_fee_id: findJobFeesId,
        months: editData?.months,
      });
      setEditorDescState(editData?.jobDescription);
      setEditorReqState(editData?.jobRequirements);
    } else if (!editData && isModalOpen) {
      // Reset form when opening for new job (no editData)
      form.resetFields();
      setEditorDescState(`<p></p>`);
      setEditorReqState(`<p></p>`);
      setValidFileList([]);
    }
  }, [editData, isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      editData?.jobLogo &&
        setValidFileList((prev) => [
          {
            uid: editData?.jobLogo?.id,
            name: displayFileName(editData?.jobLogo),
            status: 'done',
            url: `${applicationConfig.UPLOAD_URL}/${editData?.jobLogo?.name}`,
          },
        ]);
    }
  }, [isModalOpen]);

  return (
    <div className='form-container'>
      <Modal
        bodyStyle={{overflowY: 'scroll', maxHeight: 'calc(100vh - 200px)'}}
        open={isModalOpen}
        className='common-form-modal'
        prefixCls='customized-modal-v2'
        footer={null}
        onCancel={handleClose}
        closeIcon={
          <CloseCircleFilled
            className='close-icon-modal-v2'
            id='UserJobsComponent-closeButton-addJobs'
          />
        }>
        <Card
          title={
            <div className='modal-container-v2'>
              <div>
                <span className='modal-heading-v2'>
                  {ApplicationString['userJobsComponent.heading']}
                </span>
              </div>
              <div>
                <span className='modal-desc-v2'>
                  {ApplicationString['userJobsComponent.subheading.part1']}

                  {ApplicationString['userJobsComponent.subheading.part2']}
                </span>
              </div>
            </div>
          }
          bordered={false}
          className='form-card'>
          <div className='main-content-container'>
            <Form onFinish={onFinish} form={form}>
              <Row>
                <Col span={24}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='position'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.position.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            NoEmptySpaceInput(value, 'Position'),
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.position.placeholder'
                          ]
                        }
                        className='form-input-v2'
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='employer'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.employer.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            NoEmptySpaceInput(value, 'Employer'),
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.employer.placeholder'
                          ]
                        }
                        className='form-input-v2'
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='location'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.location.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            NoEmptySpaceInput(value, 'Location'),
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.location.placeholder'
                          ]
                        }
                        className='form-input-v2'
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='contact_info'
                      rules={[
                        {
                          validator: (_, value) =>
                            NoEmptySpaceInput(value, 'Contact info'),
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.contact_info.placeholder'
                          ]
                        }
                        className='form-input-v2'
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='attachment_url'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.attachment_url.validationMessage'
                            ],
                        },
                        {
                          validator: urlOrEmailValidator,
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.attachment_url.placeholder'
                          ]
                        }
                        title={
                          ApplicationString[
                            'userJobsComponent.attachment_url.placeholder'
                          ]
                        }
                        prefixCls='attachment-url-input-v2'
                        // addonBefore='https://'
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  <div>
                    <Form.Item
                      name='job_fee_id'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.job_fee_id.validationMessage'
                            ],
                        },
                      ]}>
                      <Select
                        className='form-select-v2'
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.job_fee_id.placeholder'
                          ]
                        }
                        options={jobFeesOptions}></Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div>
                    <Form.Item
                      name={'months'}
                      className='common-input-container-v2'
                      rules={[
                        {
                          required: true,
                          message: '',
                        },
                        {
                          validator: (_, value) =>
                            validateMonthsInput(value, 'Months'),
                        },
                      ]}>
                      <Input
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.months.placeholder'
                          ]
                        }
                        className='form-input-v2'
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='description'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.description.validationMessage'
                            ],
                        },
                      ]}>
                      <CommonEditor
                        v2={true}
                        removeExtraField={true}
                        value={editorDescState}
                        onChange={setEditorDescState}
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.description.placeholder'
                          ]
                        }
                        text={'jobs_form_description'}
                        placeholderValue={
                          ApplicationString[
                            'userJobsComponent.description.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className='common-input-container-v2'>
                    <Form.Item
                      name='requirement'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userJobsComponent.requirement.validationMessage'
                            ],
                        },
                      ]}>
                      <CommonEditor
                        v2={true}
                        removeExtraField={true}
                        value={editorReqState}
                        onChange={setEditorReqState}
                        placeholder={
                          ApplicationString[
                            'userJobsComponent.requirement.placeholder'
                          ]
                        }
                        text={'jobs_form_requirement'}
                        placeholderValue={
                          ApplicationString[
                            'userJobsComponent.requirement.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              {/* <Divider /> */}
              <div className='modal-footer-container'>
                <div>
                  {/* <span className='payment-text-v2'>
                    First, complete the payment to proceed with the listing
                    process.
                  </span> */}
                  {/* <div className='alert-info'>
                    <Alert
                      message={
                        <div className='alert-container'>
                          <div>
                            <span className='alert-heading'>
                              {' '}
                              New Job listing Added Successfully in queue !
                            </span>
                          </div>
                          <div>
                            <span className='alert-desc'>
                              it will take 24 Hours to be listed & once
                              moderator approve the details & Payment status
                            </span>
                          </div>
                        </div>
                      }
                      type='success'
                      closeIcon={<CloseCircleFilled className='close-icon' />}
                    />
                  </div> */}
                </div>
                <div className='modal-footer-button'>
                  <Button
                    htmlType='submit'
                    id='UserJobsComponent-submitButton-addJobs'
                    className='checkout-button-v2'
                    loading={isSubmitting}>
                    <span className='checkout-text-v2'>
                      {editData?.id
                        ? ApplicationString['userText.save']
                        : ApplicationString[
                            'userJobsComponent.submit&CheckoutText'
                          ]}{' '}
                    </span>
                  </Button>
                  <Button
                    id='UserJobsComponent-cancelButton-addJobs'
                    className='cancel-button-v2'
                    onClick={handleClose}
                    disabled={isSubmitting}>
                    <span className='cancel-text-v2'>
                      {ApplicationString['userText.cancel']}
                    </span>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Card>
      </Modal>
    </div>
  );
};

export default JobsFormComponent;
